import React, { useContext } from "react";
import { General } from "../tools/styles";
import {WatchContext} from '../WatchContext'

const SoilSummary = () => {
  let {  soil } = useContext(WatchContext);

  return (
    
    <div style={{width: '100%', display: 'flex', flexDirection: 'column'}}>
            <General.SmallHead>{soil?.title}</General.SmallHead>
            <span style={{marginTop: '1rem'}}>Soil type: {(soil?.complete && soil?.decompDepth?.length > 0)
              ? soil?.soilSuggestion 
              : "need more information"}</span><br/>
              <span>Soil grade: {(soil?.complete && soil?.finalGrade) ? soil?.finalGrade : 'need more information'}</span><br/>
              {(soil?.complete && soil?.finalGrade) ? (<span>These values are based on an organic depth of {soil?.depth}cm with a parent type of {soil?.parentType} {soil?.parentDepth.length > 0 ? `at a depth of ${soil?.parentDepth}`: null} and a decomposition level of {soil?.decompLevel}{soil?.decompDepth.length > 0 ? ` at a depth of ${soil?.decompDepth} cm` : null}.</span>) : null}
            {/* coming soon: soil consideration */}
          </div> 
     
    
  );
};

export default SoilSummary;
